export default "__VITE_ASSET__9672000d__"